<template>
  <el-dialog :title="title" :visible.sync="xzVisible" :close-on-click-modal="false" width="80%" center
    :before-close="closeadd">
    <div class="topForm">
      <el-form :model="FormData" ref="FormData" class="demo-dynamic" :rules="Rules" :inline="true">
        <el-form-item prop="instockPlateNumber" label="车号:">
          <el-input v-model="FormData.instockPlateNumber" placeholder="请输入车号" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="primaryCustomerTaxId" label="一级货主:">
          <el-select v-model="FormData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerTaxId" label="二级货主:">
          <el-select v-model="FormData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="arrivalMethod" label="到货方式:">
          <el-select v-model="FormData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="vehicleNumber" label="车船号:">
          <el-input v-model="FormData.vehicleNumber" placeholder="请输入车船号" size="mini" :maxlength='20'></el-input>
        </el-form-item>
        <el-form-item prop="ext1" label="备注:">
          <el-input v-model="FormData.ext1" placeholder="请输入备注" size="mini" :maxlength='50' type="textarea"></el-input>
        </el-form-item>
        <el-form-item prop="warehousingNo" label="出厂编号:">
          <el-input v-model="FormData.warehousingNo" placeholder="请输入出厂编号" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="contractNumber" label="合同号:">
          <el-input v-model="FormData.contractNumber" placeholder="请输入合同号" size="mini"></el-input>
        </el-form-item>
        <el-form-item prop="queueForwardUnit" label="发货单位:">
          <el-select v-model="queueForwardUnit" size="mini" placeholder="请选择发货单位" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomTable">
      <div class="detailsTitle">
        <h4>货物信息</h4>
        <el-button style="position:absolute;left:110px;" type="primary" v-if="isShowDYFlag != 2" @click="addtable">新增</el-button>
      </div>
      <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableref"
        :data="table" style="width: 100%" class="elTab">
        <el-table-column prop="productType" label="货物类型" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.productType" size="mini" placeholder="请选择货物类型"
              @change="selectProductType(scope1.row)">
              <el-option v-for="(item, index) in huowuOptions" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseId" label="仓位" align="center" v-if="isShowDYFlag==2">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei(scope1.row)">
              <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.steelMillName" size="mini" placeholder="请选择产地"
              :disabled="scope1.row.disChandi" @change="selectChandi(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.chanDiOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.specification" size="mini" placeholder="请选择规格"
              :disabled="scope1.row.disGuige" @change="selectGuige(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.guigeOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="材质" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.model" size="mini" placeholder="请选择材质"
              :disabled="scope1.row.disCaizhi" @change="selectCaizhi(scope1.row)">
              <el-option v-for="(item, index) in scope1.row.caizhiOptions" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="件数" align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.number" v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini"
              :disabled="scope1.row.disJianshu" @input="NumberInput(scope1.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="理重(吨)" align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.weight" maxlength="50" placeholder="请输入理重(吨)" size="mini"
              :disabled="scope1.row.disLizhong"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="factoryWeight" label="出厂过磅净重(吨)" align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.factoryWeight" v-number-input.float="4" maxlength="50"
              placeholder="请输入出厂过磅净重(吨)" size="mini" :disabled="scope1.row.disGbjz"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="outNumber" label="出厂车号" align="center">
          <template slot-scope="scope1">
            <el-input v-model="scope1.row.outNumber" maxlength="50" placeholder="请输入出厂车号" size="mini"
              :disabled="scope1.row.disGbjz"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="" label="编辑" align="center">
          <template slot-scope="scope1">
            <el-button @click="delClick(scope1.$index, scope1.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" style=" margin: 15px auto">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="Loading" @click="addDialog">保 存</el-button>
      <el-button type="primary" :loading="saveLoading" @click="addDialogPrint" v-if="isShowDYFlag != 2">保存并打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getVirtualBalingList,
  getWeighingMethodList,
  zidianKuwei
} from '@/api/wms-stock'
import { JfaddOrUpdateThreadExp } from '@/api/wms-access'
import { schedulingUpdateWarehouse } from '@/api/lj'
var validateInt = (rule, value, callback) => {
  if (value == 0) {
    callback(new Error('件数不能为0'))
  } else {
    callback()
  }
}
export default {
  name: 'rukuPlanDialog',
  data () {
    return {
      validateInt: validateInt,
      FormData: {
        instockPlateNumber: '',
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerTaxId: '',
        customerName: '',
        arrivalMethod: '',
        ext1: '',
        warehousingNo: '',
        vehicleNumber: '',
        contractNumber: ''
      },
      queueForwardUnit: '',
      Rules: {
        instockPlateNumber: [
          { required: true, message: '请输入车号', trigger: 'blur' }
        ],
        primaryCustomerTaxId: [
          { required: true, message: '请选择一级货主', trigger: 'change' }
        ],
        customerTaxId: [
          { required: true, message: '请选择二级货主', trigger: 'change' }
        ],
        arrivalMethod: [
          { required: true, message: '请选择到货方式', trigger: 'blur' }
        ],
        ext1: [
          { required: false, message: '请输入备注', trigger: 'blur' }
        ]
      },
      // RKData: [],
      table: [],
      Loading: false,
      chanDiOptions: [],
      huowuOptions: [],
      guigeOptions: [],
      caizhiOptions: [],
      saveLoading: false,
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      DYBtnShow: false,
      warehouseOptions: []
    }
  },
  props: {
    title: {
      type: String,
      default: '新增入库计划'
    },
    xzVisible: {
      type: Boolean,
      default: false
    },
    xztableData: {
      type: Array
    },
    xiugaiObj: {
      type: Object
    },
    RKData: {
      type: Array
    },
    isShowDYFlag: {
      type: Number
    },
    vhcNo: {
      type: String
    },
    ljjcId: {
      type: Number
    }
  },
  watch: {
    xztableData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length == 0) {
          this.table = []

          let obj = {
            steelMillName: '',
            productType: '',
            vehicleNumber: '',
            specification: '',
            model: '',
            number: '',
            weight: '',
            factoryWeight: '',
            outNumber: '',
            disChandi: true,
            disGuige: true,
            disCaizhi: true,
            disJianshu: true,
            disLizhong: true,
            disGbjz: true,
            chanDiOptions: [],
            huowuOptions: [],
            guigeOptions: [],
            caizhiOptions: []
          }
          this.table.push(obj)
        } else {
          let hwInfos = JSON.parse(window.localStorage.getItem('HwInfos'))
          val.map(item => {
            item.disLizhong = true
          })
          this.table = JSON.parse(JSON.stringify(val))
          this.table.map(item => this.getOptions(item, hwInfos))
        }
      }
    },
    xiugaiObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.FormData.instockPlateNumber = val.instockPlateNumber
          this.FormData.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.FormData.customerTaxId = val.customerTaxId
          this.FormData.arrivalMethod = val.arrivalMethod
          this.FormData.ext1 = val.ext1
          this.FormData.warehousingNo = val.warehousingNo
          this.FormData.vehicleNumber = val.vehicleNumber
          this.FormData.contractNumber = val.contractNumber
        }
      }
    }
  },
  methods: {
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.warehouseOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    selectCangwei (row) {
      if (row.warehouseId != '') {
        let warehouse = this.warehouseOptions.filter(item => item.warehouseId == row.warehouseId)[0]
        row.warehouseName = warehouse.warehouseName
      }
    },
    // 乐居进仓登记创建计划之后更新仓位信息
    schedulingUpdateWarehouse () {
      schedulingUpdateWarehouse({
        id: this.ljjcId,
        warehouseId: this.table[0].warehouseId,
        warehouseName: this.table[0].warehouseName
      })
        .then((res) => {
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    getOptions (row, hwInfos) {
      this.$set(row, 'chanDiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType).map(item => item.placeOfOrigin))))
      this.$set(row, 'guigeOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType && item.placeOfOrigin == row.steelMillName).map(item => item.specification))))
      this.$set(row, 'caizhiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType && item.placeOfOrigin == row.steelMillName && item.specification == row.specification).map(item => item.model))))
    },
    closeadd () {
      this.$emit('update:xzVisible', false)
      this.$parent.xztableData = []
      this.$parent.xiugaiObj = {}
    },
    addDialog () {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          this.Loading = true
          this.FormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.primaryCustomerTaxId)[0].custerName
          this.FormData.customerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.customerTaxId)[0].custerName
          if (this.title == '修改入库计划') {
            this.FormData.instockId = this.xiugaiObj.instockId
          }
          for (let i = 0; i < this.table.length; i++) {
            this.table[i].instockSummaryId = null
            if (this.table[i].inWeighingMethod == 3 && this.table[i].factoryWeight / 1 == 0) {
              this.$message({ message: '请填写出厂过磅净重', type: 'error' })
              this.Loading = false
              return
            } else if (this.table[i].number / 1 == 0) {
              this.$message({ message: '件数不能为空或0', type: 'error' })
              this.Loading = false
              return
            } else if (this.table[i].weight / 1 == 0) {
              this.$message({ message: '理重不能为空或0', type: 'error' })
              this.Loading = false
              return
            }
            if (this.isShowDYFlag == 2) {
              if (!this.table[i].warehouseId) {
                this.$message({ message: '仓位不能为空', type: 'error' })
                this.Loading = false
                return
              }
            }
            this.$set(this.table[i], 'queueForwardUnit', this.queueForwardUnit)
          }
          if (this.isShowDYFlag == 2) {
            this.$set(this.table[0], 'queueId', this.ljjcId)
          }
          let subTable = this.table.filter(item => item.number != 0)
          const ress = new Map()
          let arrNew = subTable.filter((arr) => !ress.has(arr.productType + arr.steelMillName + arr.specification + arr.model) && ress.set(arr.productType + arr.steelMillName + arr.specification + arr.model, 1))
          if (this.table.length != arrNew.length) {
            this.$message({ message: '请检查存在重复货物信息！', type: 'error' })
            this.Loading = false
            return
          }
          JfaddOrUpdateThreadExp(
            { ...this.FormData, tInstockSummaryList: arrNew }
          )
            .then(res => {
              if (this.isShowDYFlag == 2) {
                this.schedulingUpdateWarehouse()
              }
              setTimeout(() => {
                this.$parent.chaxun()
              }, 200)
              this.$parent.xztableData = []
              this.$parent.xiugaiObj = {}
              this.$emit('update:xzVisible', false)
            })
            .catch(err => {
              this.$message({ message: err.message, type: 'error' })
              this.Loading = false
            })
        } else {

        }
      })
    },
    addDialogPrint () {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          this.saveLoading = true
          this.FormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.primaryCustomerTaxId)[0].custerName
          this.FormData.customerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData.customerTaxId)[0].custerName
          if (this.title == '修改入库计划') {
            this.FormData.instockId = this.xiugaiObj.instockId
          }
          for (let i = 0; i < this.table.length; i++) {
            this.table[i].instockSummaryId = null
            if (this.table[i].inWeighingMethod == 3 && this.table[i].factoryWeight == '') {
              this.$message({ message: '请填写出厂过磅净重', type: 'error' })
              this.saveLoading = false
              return
            }
          }
          let subTable = this.table.filter(item => item.number != 0)
          const ress = new Map()
          let arrNew = subTable.filter((arr) => !ress.has(arr.productType + arr.steelMillName + arr.specification + arr.model) && ress.set(arr.productType + arr.steelMillName + arr.specification + arr.model, 1))
          if (this.table.length != arrNew.length) {
            this.$message({ message: '请检查存在重复货物信息！', type: 'error' })
            this.saveLoading = false
            return
          }
          JfaddOrUpdateThreadExp(
            { ...this.FormData, tInstockSummaryList: arrNew }
          )
            .then(res => {
              this.$parent.xztableData = []
              this.$parent.xiugaiObj = {}
              this.$emit('update:xzVisible', false)
              this.$router.push({
                path: '/xiecheDanPrint',
                query: {
                  id: res
                }
              })
            })
            .catch(err => {
              this.$message({ message: err.message, type: 'error' })
              this.saveLoading = false
            })
        } else {

        }
      })
    },
    delClick (index, row) {
      if (this.table.length == 1) {
        this.$alert('最后一条货物信息不能删除', '系统提示')
        return
      }
      this.table.splice(index, 1)
    },
    addtable () {
      let obj = {
        steelMillName: '',
        productType: '',
        productTypeName: '',
        specification: '',
        model: '',
        number: '',
        weight: '',
        outNumber: '',
        factoryWeight: '',
        disChandi: true,
        disGuige: true,
        disCaizhi: true,
        disJianshu: true,
        disLizhong: true,
        disGbjz: true,
        chanDiOptions: [],
        huowuOptions: [],
        guigeOptions: [],
        caizhiOptions: []
      }
      this.table.push(obj)
    },
    getVirtualBalingLists () {
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          window.localStorage.setItem('HwInfos', JSON.stringify(res))
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.huowuOptions = arrNew
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    selectProductType (row) {
      row.disChandi = false
      row.disGuige = true
      row.disCaizhi = true
      row.disJianshu = true
      row.disJianshu = true
      row.disGbjz = true
      row.steelMillName = ''
      row.vehicleNumber = ''
      row.specification = ''
      row.model = ''
      row.number = ''
      row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''
      row.chanDiOptions = []
      row.guigeOptions = []
      row.caizhiOptions = []
      row.productTypeName = this.huowuOptions.filter(item => item.id == row.productType)[0].name

      getWeighingMethodList(
        {
          productType: row.productType
        }
      )
        .then(res => {
          if (res.length > 0) {
            row.inWeighingMethod = res[0].inWeighingMethod
            if (row.productType != '') {
              getVirtualBalingList(
                { ...row }
              )
                .then(res => {
                  row.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                })
            }
          } else {
            this.$message({ message: '计重方式未配置，请联系管理员', type: 'error' })
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    selectChandi (row) {
      row.disGuige = false
      row.disCaizhi = true
      row.disJianshu = true
      row.disJianshu = true
      row.disGbjz = true
      row.specification = ''
      row.model = ''
      row.number = ''
      row.weight = ''
      row.factoryWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''

      row.guigeOptions = []
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName
      if (row.steelMillName != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectGuige (row) {
      row.disCaizhi = false
      row.disJianshu = true
      row.disGbjz = true
      row.model = ''
      row.number = ''
      row.weight = ''
      row.singletonWeight = ''

      row.factoryWeight = ''
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName

      if (row.specification != '') {
        getVirtualBalingList({ ...row })
          .then(res => {
            row.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }
    },
    selectCaizhi (row) {
      row.disJianshu = false
      row.disGbjz = true
      row.number = ''
      row.weight = ''
      row.placeOfOrigin = row.steelMillName
      row.factoryWeight = ''
      row.singletonWeight = ''
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      getVirtualBalingList({ ...row })
        .then(res => {
          loading.close()

          row.singletonWeight = res[0].weight
        })
        .catch(err => {
          loading.close()

          this.$message({ message: err.message, type: 'error' })
        })
    },
    NumberInput (row) {
      row.disGbjz = false
      row.weight = parseFloat((row.number / 1 * row.singletonWeight).toFixed(6))
    }
  },
  created () {
    this.getVirtualBalingLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.addDialogPrint()
      }
    }
  },
  mounted () {
    this.zidianKuweiS()
    if (this.vhcNo) {
      this.FormData.instockPlateNumber = this.vhcNo
    }
  }

}
</script>

<style></style>
